import { Http } from '../../shared';
import { settings } from '../../settings';

export class EmailService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }


    async sendOrderCreationEmail(id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send' + tokenQuery, { email_template: 'creation', attach_pdf: true, attach_qrcode: false });
        return response.data;
    }
    async sendOrderCancellationEmail(id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send' + tokenQuery, { email_template: 'cancellation', attach_pdf: false, attach_qrcode: false });
        return response.data;
    }
    async sendLegCancellationEmail(id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send' + tokenQuery, { email_template: 'leg-cancellation', attach_pdf: true, attach_qrcode: false  });
        return response.data;
    }
    async sendOrderChangeEmail(id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(this.service_url + '/emails/orders/' + id + '/send' + tokenQuery, { email_template: 'change', attach_pdf: true, attach_qrcode: false  });
        return response.data;
    }
}
